import { useState, useEffect } from 'react';
import Bowser from 'bowser';
import { isBrowserSupported } from 'livekit-client';

interface IBrowserInfo {
  name: string;
  platform: string;
  version: string;
}

interface IBrowserCompatibility {
  browserInfo: IBrowserInfo;
  isCompatible: boolean;
}

export const useBrowserCompatibility = (): IBrowserCompatibility => {
  const [compatibility, setCompatibility] = useState<IBrowserCompatibility>({
    isCompatible: false,
    browserInfo: {
      name: '',
      platform: '',
      version: '',
    },
  });

  useEffect(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserName = browser.getBrowserName();
    const platformType = browser.getPlatformType();
    const osName = browser.getOSName();
    const osVersion = browser.getOSVersion();
    const browserVersion = browser.getBrowserVersion();

    let platform = `${osName} ${osVersion}`;
    if (platformType === 'desktop') {
      platform += ' (desktop)';
    } else if (platformType === 'mobile') {
      platform += ' (mobile)';
    }

    setCompatibility({
      isCompatible: isBrowserSupported(),
      browserInfo: {
        name: browserName,
        platform,
        version: browserVersion,
      },
    });
  }, []);

  return compatibility;
};
